// extracted by mini-css-extract-plugin
export default {"content":"VREw","aligntext":"E1El"};